(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description-clamp"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-description-clamp]').forEach(function (wrapper) {
    if (wrapper.dataset.clampInit) return;
    wrapper.dataset.clampInit = 'true';

    var content = wrapper.querySelector('[data-clamp-content]');
    var toggle = wrapper.querySelector('[data-clamp-toggle]');
    var moreLabel = wrapper.querySelector('[data-clamp-toggle-more]');
    var lessLabel = wrapper.querySelector('[data-clamp-toggle-less]');
    if (!content || !toggle) return;

    function checkOverflow() {
      content.setAttribute('data-clamped', '');
      var isOverflowing = content.scrollHeight > content.clientHeight + 1;
      if (isOverflowing) {
        toggle.hidden = false;
      } else {
        toggle.hidden = true;
        content.removeAttribute('data-clamped');
      }
    }

    requestAnimationFrame(checkOverflow);
    window.addEventListener('resize', checkOverflow);

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        content.setAttribute('data-clamped', '');
        toggle.setAttribute('aria-expanded', 'false');
        moreLabel.hidden = false;
        lessLabel.hidden = true;
      } else {
        content.removeAttribute('data-clamped');
        toggle.setAttribute('aria-expanded', 'true');
        moreLabel.hidden = true;
        lessLabel.hidden = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
